export default __webpack_public_path__ + "c03182c929527122107d13d2d03569c3.png";